<template>
  <div id="root"
  >
    <div class="mask"
         v-loading="this.lock"
         element-loading-text="拼命加载中"
         element-loading-spinner="el-icon-loading"
         element-loading-background="rgba(0, 0, 0 ,0.3)"></div>

    <div class="header_model">
      <div class="line_vertical"></div>
      <div class="header_title">{{pageTitle}}</div>
    </div>
     <div class="content_model">
      <slot></slot>
     </div>
  </div>

</template>

<script>
import {mapState} from "vuex";
import {Message} from "element-ui";

export default {
  name: "modelframe",
  props:['message'],
  data(){
    return {
      lock:false
    }
  },
  computed:{
    ...mapState(['pageTitle'])
  },
  watch:{
    message:{//规定状态的监视属性，0为正常（关闭状态展示），1为 加载数据，2 为加载成功，-1 为加载失败
      immediate:true,
      deep:true,
      handler(val){
        switch (val.code){
          case -1:
            this.lock = false;
            Message({
              showClose: true,
              message: val.msg?val.msg:'加载失败！',
              type: 'error'
            });
            break;
          case 0:
            this.lock = false;
            break;
          case 1:
            this.lock =true;
            break;
          case 2:
            this.lock = false;
            Message({
              showClose: true,
              message: val.msg?val.msg:'数据加载成功！',
              type: 'success'
            });
            break;
        }
      }
    }
  }
}
</script>

<style scoped>
  #root{
    font-family: '微软雅黑', sans-serif;
    max-height: calc(100vh - 160px);
  }
  .line_vertical{
    height: 2rem;
    line-height: 2rem;
    width: 0;
    border-left: .6rem solid #22bb9d;
    margin-top: 1rem;
    display: inline-block;
    position: absolute;
    padding-right: 1rem;
  }
  .header_title{
    margin-left: 1rem;
  }
  .header_model{
    width: 100%;
    height: 4.2rem;
    background-color: #f9f9f9;
    padding-left: 5%;
    line-height: 4.2rem;
    font-weight: bold;
    font-style: normal;
    position: relative;
    font-size: 16px;
    color: #999999;
    text-align: left;
    display: flex;
  }
  .content_model{
    width: 90%;
    height: calc(100vh - 160px - 4.2rem - 10px);
    position: relative;
    margin-left: 5%;
    margin-top: 10px;
    padding: 0;
    box-sizing: border-box;
    border:1px solid #e4e4e4;
  }
  .mask{
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
  }


</style>
